import { TextField } from "@mui/material";
import Checkbox from "./CheckBox";
import RadioBoxGroup from "./RadioBoxGroup";
import Select from "./Select";
import GroupedSelect from "./GroupedSelect";
import ToggleSwitch from "./ToggleSwitch";
import Slider from "./Slider";
import DateTimePicker from "../DateTimePicker";
import IpInput from "./IpInput";
import BasicDatePicker from "../DatePickers/BasicDatePicker";
import BasicTimePicker from "../DatePickers/BasicTimePicker";

export const getInputComponent = (type) => {
  switch (type) {
    case "checkbox":
      return Checkbox;
    case "radioboxgroup":
      return RadioBoxGroup;
    case "select":
      return Select;
    case "groupselect":
      return GroupedSelect;
    case "toggleswitch":
      return ToggleSwitch;
    case "slider":
      return Slider;
    case "date":
      return DateTimePicker;
    case "datepicker":
      return BasicDatePicker;
    case "timepicker":
      return BasicTimePicker;
    case "ipInput":
      return IpInput;
    default:
      return TextField;
  }
};
